import { Package } from "@core/models/package.model";
import { PlacementCategory } from "@core/models/placement-category.model";
import { Placement } from "@core/models/placement.model";

export class AdViewModel {

	placementCategory? : PlacementCategory;
	placement? : Placement;
	package? : Package;
	issueDates: readonly Date[];

	priceNetExTax?: number;
	priceNetIncTax?: number;
	tax?: number;
	paidAmount?: number;
	currencyCode?: string;

	constructor() {
//		this.placementCategoryId = undefined;
		this.issueDates = [];

		this.priceNetExTax = 0.00;
		this.priceNetIncTax = 0.00;
		this.paidAmount = 0.00;
	}

}
